import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { SelectedItemsBox } from './selectionPanel/selectedItemsBox';
import { SearchBar } from '../search/searchBar';
export const AddValuesPanel = t0 => {
  const $ = _c(21);
  const {
    entityName,
    addedValues,
    onAddClick,
    renderItem,
    itemKey,
    onRemove,
    clearAll
  } = t0;
  const [input, setInput] = useState("");
  const t1 = `Add one or more ${entityName}${entityName.endsWith("s") ? "es" : "s"}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <Typography padding="12px 24px" variant="body1">{t1}</Typography>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Divider />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== addedValues || $[4] !== entityName || $[5] !== input || $[6] !== onAddClick) {
    t4 = <Stack padding="0 24px 12px"><SearchBar value={input} setValue={setInput} placeholder={entityName} selectedValues={addedValues} onAddClick={onAddClick} showAddButton={true} hideSearchIcon={true} /></Stack>;
    $[3] = addedValues;
    $[4] = entityName;
    $[5] = input;
    $[6] = onAddClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== addedValues || $[9] !== clearAll || $[10] !== entityName || $[11] !== itemKey || $[12] !== onRemove || $[13] !== renderItem) {
    t5 = addedValues.length > 0 && <SelectedItemsBox items={addedValues} entityType={entityName} renderItem={renderItem} itemKey={itemKey} onRemove={onRemove} clearAll={clearAll} />;
    $[8] = addedValues;
    $[9] = clearAll;
    $[10] = entityName;
    $[11] = itemKey;
    $[12] = onRemove;
    $[13] = renderItem;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <Stack gap="12px" divider={t3} overflow="hidden">{t4}{t5}</Stack>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t6) {
    t7 = <Stack className="max-h-[480px] overflow-hidden" marginTop="12px">{t2}{t6}</Stack>;
    $[18] = t2;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};